import { FilterItemDto } from '../request/filter-item.dto';
import { SorterItemDto } from '../request/sorter-item.dto';

export class ListRequestDto {
    skipCount: number;
    maxResultCount: number;
    filters: FilterItemDto[];
    sorters: SorterItemDto[];
}
